<template>
    <div style="background:#ffffff">
        <div class="w">
            <div class="oheader">
                <a href="/" title="夜樱情趣" class="left">
                    <img src="../../assets/image/logo.png">
                </a>
                <!-- <a href="javascript:;" onclick="jieshou()" class="xhb right"><em class="f pr5 f14"></em>联系客服</a> -->
                <a href="/" class="xhb right mr10">继续购物</a>
                <div class="clear"></div>
            </div>
        </div>
        <div class="w" id="content">
            <h1 style="font-size:24px;font-weight:bold;margin-top:20px;border-bottom: 1px dotted rgb(221, 221, 221);padding-bottom:20px;line-height: 20px;">订单信息</h1>
            <div class="address-tips-top"></div>
            <div style="margin:30px 0px;">
                <h3 style="font-size:18px;position: relative;margin-bottom: 15px;">收货信息</h3>
                <div class="address-list" v-if="firstAddress == '暂无收货地址可使用'">
                    <p style="font-size:20px;text-align:center;line-height:36px;">{{firstAddress}}</p>
                </div>
                <div class="address-list" v-else>
                    <div class="TwoRow" v-for="(item,index) in list" :key="index">
                        <div class="background" :class="{activeAddress:index == num}" @click="rechargeAddress(index)">
                            <div class="addr-hd">
                                <span>{{item.name}}</span>
                                <span>({{item.tel}})</span>
                            </div>
                            <div class="addr-bd">
                                <span>{{item.province}}</span>
                                <span>{{item.city}}</span>
                                <span>{{item.area}}</span>
                                <span>{{item.town}}{{item.address}}</span>
                            </div>
                            <div class="modify-operation">默认地址</div>
                        </div>
                    </div>
                </div>allPrice
                <div class="operations">
                    <button type="button" class="next-btn next-medium next-btn-normal operation" @click="addNewAddress()">使用新地址</button>
                </div>
                
            </div>  
            <div>
                <h3 style="font-size:18px;position: relative;margin-bottom: 15px;">确认订单信息</h3>
                <div class="item-headers-wrap item-headers-column-6">
                    <div class="item-headers-content item-headers-0">商品信息</div>
                    <div class="item-headers-content item-headers-1">商品属性</div>
                    <div class="item-headers-content item-headers-2">单价</div>
                    <div class="item-headers-content item-headers-3">数量</div>
                    <div class="item-headers-content item-headers-3">会员优惠折扣</div>
                    <div class="item-headers-content item-headers-4">小计</div>
                </div>
                <div style="margin-top:10px;overflow: hidden;">
                    <div class="item-headers-content0 item-headers-0" style="float:left;text-align:center;">
                        <img :src="piclink" alt="" width="70" height="70" style="float:left;margin-right:10px;">
                        <span>{{title}}</span>
                    </div>
                    <div class="item-headers-content0 item-headers-1" style="float:left;text-align:center;" v-if="ptitle != ''">
                        {{ptitle}}
                    </div>
                    <div class="item-headers-content0 item-headers-1" style="float:left;text-align:center;" v-else>
                        无
                    </div>
                    <div class="item-headers-content0 item-headers-2" style="float:left;text-align:center;">
                        {{$fnc.toFixedZ(price,2)}}
                    </div>
                    <div class="item-headers-content0 item-headers-3" style="float:left;text-align:center;">
                        X{{number}}
                    </div>
                    <div class="item-headers-content0 item-headers-3" style="float:left;text-align:center;">
                         <!-- {{$fnc.toFixedZ(addOrderInfo.offer)}} -->
                         {{parseFloat(addOrderInfo.offer).toFixed(2)}}
                    </div>
                    <div class="item-headers-content0 item-headers-4" style="float:left;text-align:center;">
                        {{$fnc.toFixedZ(addOrderInfo.sum_price)}}
                    </div>
                </div>
            </div>
            <div style="margin:30px 0px 15px 0;overflow:hidden">
                <h3 style="font-size:18px;position: relative;margin-bottom: 15px;">商品优惠券</h3>
                <div class="address-list" v-if="firstCoupon == '暂无优惠券可使用'">
                    <p style="font-size:20px;text-align:center;line-height:20px;">{{firstCoupon}}</p>
                </div>
                <div class="address-list" v-else>
                    <div class="TwoRow" v-for="(item,index) in options" :key="index" @click="clickCoupon(index)">
                        <div class="background" :class="{activeCoupon:index == cous}">
                            <div class="addr-hd">
                                <span>{{item.limit_lv_cn}}</span>
                            </div>
                            <div class="addr-bd" style="text-align:center;font-size:20px;line-height: 36px;">
                                <span style="color:#f00180;"><b>减 {{item.money}} 元</b></span>
                            </div>
                            <div class="modify-operation">优惠券</div>
                        </div>
                    </div>
                    <div style="text-align:right;font-size:16px;">
                        <p>优惠卷抵扣：<b style="color:#f00180;">￥ {{couMoney}}元</b></p>
                    </div>
                </div>
            </div>
            <div style="margin:30px 0px 15px 0;overflow:hidden">
                <h3 style="font-size:18px;position: relative;margin-bottom: 15px;">给卖家留言</h3>
                <div>
                    <textarea name="" id="" cols="30" rows="10" class="f12 ipt" style="width:1180px;" v-model="remarks"></textarea>
                </div>
            </div>
            <div style="margin:30px 0px 15px 0;overflow:hidden;font-size:16px;text-align:right;">
                (含运费)总计：<span style="color:#f00180;font-size:20px;font-weight:bold;">{{allPrice}}元</span>
            </div>
            <div style="border-bottom: 1px dotted rgb(221, 221, 221);padding-bottom:20px;"></div>
            <!-- <div style="margin:30px 0px 15px 0;overflow:hidden">
                <h3 style="font-size:18px;position: relative;margin-bottom: 15px;">选择付款方式</h3>
                <ul id="fukuan" class="payl">
                    <li class="pmz" data-id="3" data-by="198" data-j="0" v-for="(pay,pindex) in payList" :key="pindex" @click="clickPay(pindex)" :class="{active:pindex == pays}">
                        <img :src="pay.piclink" class="by_ico">
                        <em class="pm_l">{{pay.title}}</em>
                        <i class="pm_ff">{{pay.iden}}</i>
                    </li>
                </ul>
            </div> -->
            <div data-halo-id="realPayPC_1" data-halo-type="realPay">
                <div class="realpay order-payInfo" id="realPayPC_1">
                    <div class="box">
                        <div class="box__wrapper">
                            <div class="box__shadow">
                                <div>
                                    <span class="realpay--title">实付款：</span>
                                    <span class="realpay--price-symbol">¥</span>
                                    <span class="realpay--price" style="color: #f00180">{{allPrice}}元</span>
                                </div>
                                <div class="order-confirmAddr" v-if="firstAddress == '暂无地址可使用'">
                                    <div class="confirmAddr-addr">
                                        <span class="confirmAddr-title">寄送至：</span>
                                        <span class="confirmAddr-addr-bd">无</span>
                                    </div>
                                    <div class="confirmAddr-addr-user">
                                        <span class="confirmAddr-title">收货人：</span>
                                        <span class="confirmAddr-addr-bd">无</span>
                                    </div>
                                </div>
                                <div class="order-confirmAddr" v-else>
                                    <div class="confirmAddr-addr">
                                        <span class="confirmAddr-title">寄送至：</span>
                                        <span class="confirmAddr-addr-bd"> {{firstAddress.province}}{{firstAddress.city}}{{firstAddress.area}}{{firstAddress.town}}{{firstAddress.address}}</span>
                                    </div>
                                    <div class="confirmAddr-addr-user">
                                        <span class="confirmAddr-title">收货人：</span>
                                        <span class="confirmAddr-addr-bd">{{firstAddress.name}} {{firstAddress.tel}}</span>
                                    </div>
                                </div>
                                <div class="order-confirm-eticket"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-halo-id="submitOrderPC_1" data-halo-type="submitOrder">
                <div class="submitOrder-container" id="submitOrderPC_1">
                    <div class="wrapper">
                        <a role="button" title="提交订单" class="go-btn" style="background-color: #f00180" @click="subOrder()">提交订单</a>
                    </div>
                </div>
            </div>
        </div>
        <p class="bf_footer">
            <a href="/" class="c9" target="_blank">首页</a>
            <em class="vline">|</em>
            <a href="javascript:;" class="c9"  v-for="(items,index) in category" :key="items.id"  @click="catesearch(items.title,index)">
                {{items.title}}
                <em class="vline">|</em>
            </a>
        </p>
        <p class="fuwu">下单代表同意夜樱情趣 <a href="/help/fuwuxieyi" class="U" target="_blank">服务协议</a><a href="/help/falvshengming" class="U" target="_blank">法律声明</a><a href="/help/yinsibaohu" class="U" target="_blank">隐私政策权</a></p>
    </div>
</template>

<script>
import CryptoJS from "crypto-js"
export default {
    data(){
        return{
            activeName: 0,
            list:[],
            show:false,
            active:0,
            activeAddress:"",
            activeCoupon:"",
            num:"",
			//nav
            category:[],
            type: 1,
            piclink:"",
            title:"",
            ptitle:"",
            number:"",
            price:"",
            id:"",
            pcoupon:{},
            allPrice:"",
            Provinces:'',
            Province: '',
            city: '',
            city1: [],
            area: '',
            area1: [],
            cities:'',
            block:'',
            params: {
                name: "",
                tel: "",
                address: "",
                town: "",
                house: "" //门牌号
            },
            coupon1: [],
            coupon2: [],
            addOrder:{},
            pskui:"",
            couLength:"",
            addOrderInfo:{},
            acart:"",
            shopInfo: {
                img_json: [],
                one_talk: {},
                recommend: [],
                hot: [],
                group: {
                    data: []
                }
            },
            orderInfoData:{},
            options:[],
            value:"",
            recharges:"",
            checkCoupon:"",
            cous:0,
            couMoney:"",
            sum:"",
            couponPrice: 0,
            payList:{},
            pays:0,
            payRechanges:"",
            checkAddress:"",
            remarks:"",
            firstCoupon:JSON.parse(window.localStorage.getItem("appstore")),
            firstAddress:JSON.parse(window.localStorage.getItem("address")),
            form: {
                id_str: "",
                is_integral: 0, //是否积分抵用
                red_id: "", //使用红包ID
                is_invoice: 0, //是否使用发票,
                reserve_time: "",
                friend: "",
                is_lifting: 0,
                gb_types: 0,
                gb_num: "",
            },
            is_coupon:"",
        }
    },
    mounted(){
        this.getAddress(JSON.parse(window.localStorage.getItem("user")).id);
        this.getCacheInfo();
        this.getShopCate();
        this.getPayMethod();
    },
    methods:{
        //获取所有商品分类
        getShopCate() {
            this.$api.getCategory.getShopCate({}).then(res => {
                if (res.code == 200) {
                    this.category = [];
                    var arr = res.result.cate;
                    arr.forEach(item => {
                        if (item.show == 1) {
                            this.category.push(item);
                        }
                    });
                    this.type = res.result.types;
                }
            });
        },
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
        getCardNumber () {
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCardNumber(cart_params).then(res => {
                if (res.code == 200) {
                    this.shopInfo.cart_number = res.result.number;
                    this.shopInfo.all_cart_number = res.result.all_product;
                }
            });
        },
        getCardLineNu (skuTitle) {
            var card = this.cardList;
            var cards = card.cardlist;
            var sid = this.$route.query.id || 0;
            if (
                card.cardID != sid &&
                cards[sid + "cardItem"] == undefined &&
                cards[sid + "cardItem"][0] == undefined &&
                cards[sid + "cardItem"][0].data.length == 0
            ) {
                return;
            } else {
                var str = skuTitle.join(" ").trim();
                var arr = cards[sid + "cardItem"][0].data;
                for (var i in arr) {
                if (arr[i].sku_cn.trim() == str) {
                    this.number = arr[i].number;
                    this.checkSkuTitle = str;
                    break;
                } else {
                    this.checkSkuTitle = str;
                    this.number = 1;
                }
                }
            }
        },
        //获取缓存信息
        getCacheInfo(){
            //获取产品的全部信息
            
            this.pskui = JSON.parse(window.localStorage.getItem("productData")).iden.split(':');
            var cart_id = JSON.parse(window.localStorage.getItem("productData")).pid;
            var cart_params = {};
            cart_params.pid = cart_id || "";
            //解密操作
            var tk = localStorage.getItem("number");//把存储的值取出
            var bytes = CryptoJS.AES.decrypt(tk, "secretkey1");
            var originalText = bytes.toString(CryptoJS.enc.Utf8);
            var prices = localStorage.getItem("payPrice");//把存储的值取出
            var bytes = CryptoJS.AES.decrypt(prices, "secretkey1");
            var payPrices = bytes.toString(CryptoJS.enc.Utf8);

            cart_params.number = originalText;
            cart_params.sku_iden = JSON.parse(window.localStorage.getItem("productData")).iden;
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            var params = {};
            params.id = this.pskui[1];
            this.$api.getShop.getSkuTitle(params).then(res=>{
                if(res.code == 200){
                    this.$api.getShop.addCart(cart_params).then(res=>{
                        if(res.code == 200){
                            this.acart = res.result;
                            this.getCardNumber();
                            var oparams = {};
                            oparams.id_str = res.result.id;
                            oparams.uid = JSON.parse(window.localStorage.getItem("user")).id;
                            oparams.address_id = JSON.parse(window.localStorage.getItem("address")).id;
                            this.$api.getShop.addOrder(oparams).then(ress=>{
                                if(ress.code == 200){
                                    this.addOrderInfo = ress.result;
                                    this.couLength = ress.result.red.length;
                                    var orderInfoData = ress.result.cart[0].data;
                                    orderInfoData.forEach((item,index)=>{
                                        this.ptitle = item.sku_cn;
                                        this.number = item.number;
                                        this.title = item.pro.title;
                                        this.piclink = item.pro.piclink;
                                        // this.price = item.pro.original_price;
                                        //解密操作
                                        this.price = payPrices;

                                        this.is_coupon = item.pro.is_coupon;
                                    })
                                    //加密操作
                                    this.allPrice = Number(this.addOrderInfo.sum_price);
                                    const payAllPrice = JSON.stringify(this.allPrice);
                                    let cipherText = CryptoJS.AES.encrypt(payAllPrice, "secretkey1").toString();                 
                                    localStorage.setItem("payAllPrice", cipherText);//本地存储

                                    // this.allPrice = JSON.parse(window.localStorage.getItem("payPrice")) * JSON.parse(window.localStorage.getItem("number"));
                                    //判断是否有优惠券
                                    if(this.is_coupon == 1 ){
                                        this.options = [];
                                        var arr = ress.result.red;
                                        if(arr != ""){
                                            arr.forEach((m,n)=>{
                                                if(m.is_cat == 1){
                                                    this.options.push(m);
                                                    var appstore = JSON.stringify(this.options[0]);//将获取到的数据转换为json数据
                                                    window.localStorage.setItem('appstore', appstore);
                                                    this.couMoney = JSON.parse(window.localStorage.getItem("appstore")).money;
                                                    this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
                                                    const payAllPrices = JSON.stringify(this.allPrice);
                                                    // window.localStorage.setItem("payAllPrice",payAllPrice);

                                                    let payAllPrice = CryptoJS.AES.encrypt(payAllPrices, "secretkey1").toString();                 
                                                    localStorage.setItem("payAllPrice", payAllPrice);//本地存储

                                                }else{
                                                    var appstore = JSON.stringify('暂无优惠券可使用');
                                                    window.localStorage.setItem('appstore', appstore);
                                                }
                                            })
                                        }else{
                                            var appstore = JSON.stringify('暂无优惠券可使用');
                                            window.localStorage.setItem('appstore', appstore);
                                        }
                                    }else{
                                        var appstore = JSON.stringify('暂无优惠券可使用');
                                        window.localStorage.setItem('appstore', appstore);
                                    }
                                    var orderInfo = JSON.stringify(ress);//将获取到的数据转换为json数据
                                    window.localStorage.setItem('orderInfo', orderInfo);
                                    
                                }
                            })
                        }
                    })
                }
            })
        },
        //获取地址列表
        getAddress(id){
            var params = {};
            params.id = id || "";
            this.$api.getUser.getAddress(params).then(res=>{
                this.list = [];
                var arr = res.result;
                if(arr != ""){
                    arr.forEach((item,index)=>{
                        this.list.push(item);
                        var address = JSON.stringify(this.list[0]);//将获取到的数据转换为json数据
                        window.localStorage.setItem('address', address);
                    })
                }else{
                    var address = JSON.stringify('暂无收货地址可使用');
                    window.localStorage.setItem('address', address);
                }
            })
        },
        //增加新地址
        addNewAddress(){
            //指定跳转地址
			this.$router.push('/add_address')
        },
        //切换地址
        rechargeAddress(item){
            this.num = item;
            this.recharges = this.list[this.num];
            if(this.recharges){
                var address = JSON.stringify(this.recharges);//将获取到的数据转换为json数据
                window.localStorage.setItem('address', address);
                this.firstAddress = JSON.parse(window.localStorage.getItem("address"));
            }
            
            // this.checkAddress = {
            //     phone: this.recharges.tel,
            //     name: this.recharges.name,
            //     province: this.recharges.province,
            //     city:this.recharges.city,
            //     area:this.recharges.area,
            //     town:this.recharges.town,
            //     address:this.recharges.address,
            // };
            // if(item === 0){
            //     this.num = 0;
            //     this.recharges = this.list[this.num];
            //     this.checkAddress = {
            //        phone: this.recharges.tel,
            //        name: this.recharges.name,
            //        province: this.recharges.province,
            //        city:this.recharges.city,
            //        area:this.recharges.area,
            //        town:this.recharges.town,
            //        address:this.recharges.address,
            //     };
            // }else{
            //     this.num = item;
            //     this.recharges = this.list[this.num];
            //     this.checkAddress = {
            //        phone: this.recharges.tel,
            //        name: this.recharges.name,
            //        phone: this.recharges.tel,
            //        name: this.recharges.name,
            //        province: this.recharges.province,
            //        city:this.recharges.city,
            //        area:this.recharges.area,
            //        town:this.recharges.town,
            //        address:this.recharges.address,
            //     };
            // }
        },
        //切换优惠券
        clickCoupon(item){
            this.cous = item;
            this.activeCoupon = item;
            this.checkCoupon = this.options[this.cous];
            // this.couMoney = this.options[this.cous].money;
            // if(this.options[this.cous].money){
            //     this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
            // }
            if(this.checkCoupon){
                var appstore = JSON.stringify(this.checkCoupon);//将获取到的数据转换为json数据
                window.localStorage.setItem('appstore', appstore);
                this.couMoney = JSON.parse(window.localStorage.getItem("appstore")).money;
                if(this.options[this.cous].money){
                    this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
                }
                // this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
            }
            
            // if(item === 0){
            //     this.cous = 0;
            //     this.activeCoupon = 0;
            //     this.checkCoupon = this.options[this.cous];
            //     this.couMoney = this.options[this.cous].money;
            //     if(this.options[this.cous].money){
            //         this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
            //     }
            // }else{
            //     this.cous = item;
            //     this.activeCoupon = item;
            //     this.checkCoupon = this.options[this.cous];
            //     this.couMoney = this.options[this.cous].money;
            //     if(this.options[this.cous].money){
            //         this.allPrice = Number(this.addOrderInfo.sum_price) - Number(this.couMoney);
            //     }
            // }
        },
        //切换支付方式
        clickPay(item){
            this.pays = item;
            this.active = item;
            this.payRechanges = this.payList[this.pays];
            // if(item === 0){
            //     this.pays = 0;
            //     this.active = 0;
            //     this.payRechanges = this.payList[this.pays];
            // }else{
            //     this.pays = item;
            //     this.active = item;
            //     this.payRechanges = this.payList[this.pays];
            // }
        },
        //支付方式
        getPayMethod(){
            this.$api.getShop.getOrderPay({}).then(res=>{
                if(res.code == 200){
                    this.payList = res.result;
                }
            })
        },
        subOrder(){
            this.$confirm('是否提交订单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(()=>{
                
                var params = {};
                params = this.form;
                params.id_str = this.acart.id || "";
                params.remarks = this.remarks || "";
                if (this.addOrderInfo.is_virtual == 0 && this.addOrderInfo.types != 14 && this.form.is_lifting == 0) {
                    params.address_id = JSON.parse(window.localStorage.getItem("address")).id || "";
                    if(params.address_id == ""){
                        this.$confirm('地址还没填写咯，请先填写收货地址！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                        });
                    }else{
                        params.mail_latitude = this.addOrderInfo.address.latitude || ''
                        params.mail_longitude = this.addOrderInfo.address.longitude || ''
                    }
                    
                }
                if(JSON.parse(window.localStorage.getItem("appstore")) != '暂无优惠券可使用'){
                    params.red_id = JSON.parse(window.localStorage.getItem("appstore")).id;
                }else{
                    params.red_id = "";
                }
                params.uid = JSON.parse(window.localStorage.getItem("user")).id;
                this.$api.getOrder.setOrder(params).then(res=>{
                    if(res.code == 200){
                        this.$router.push({path:'/payorder', query:{id:res.result,uid:JSON.parse(window.localStorage.getItem("user")).id,showVideo:1,}})
                    }
                });
            });
            // if(JSON.parse(window.localStorage.getItem("address")) == ''){
            //     this.$confirm('地址还没填写咯，请先填写收货地址！', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //     });
            // }else{
                
            // }
        }
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
@import url('../../assets/css/car.css');
.address-tips-top{
    margin-top: -10px;
    margin-bottom: 5px;
}
.address-list {
    width: 1200px;
}
.TwoRow{
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 237px;
    margin: 0 14px 14px 0;
    color: #666;
    cursor: pointer;
}
.modify-operation{
    color: #c97;
}
.background{
    z-index: 2;
    position: relative;
    padding: 11px 15px;
    background: url(../../assets/image/order/order.png) no-repeat;
    overflow: hidden;
}
.background:hover{
    z-index: 2;
    position: relative;
    padding: 11px 15px;
    background: url(../../assets/image/order/order-hover.png) no-repeat;
    overflow: hidden;
}
.activeAddress{
    z-index: 2;
    position: relative;
    padding: 11px 15px;
    background: url(../../assets/image/order/order-hover.png) no-repeat;
    overflow: hidden;
}
.activeCoupon{
    z-index: 2;
    position: relative;
    padding: 11px 15px;
    background: url(../../assets/image/order/order-hover.png) no-repeat;
    overflow: hidden;
}
.active{
    color: #000;
    background: url(../../assets/image/v.png) right -474px no-repeat;
    border-color: #f00180;
    border-width: 2px;
    padding: 7px 9px 7px 39px;
    -webkit-box-shadow: 0px 0px 5px #f5a0aa;
    box-shadow: 0px 0px 5px #f5a0aa;
}
.addr-hd {
    width: 100%;
    border-bottom: 1px solid #f2f2f2;
    padding: 0 0 5px;
    margin-bottom: 5px;
    line-height: 18px;
    font-weight: 700;
}
.addr-hd span {
    vertical-align: top;
}
.addr-hd, .addr-hd span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.addr-bd {
    height: 55px;
    overflow: hidden;
    height: 36px;
}
.addr-bd, .addr-bd span {
    word-break: break-all;
    word-wrap: break-word;
}
.item-headers-wrap {
    margin-top: 15px;
    color: #6c6c6c;
}
.item-headers-0 {
    width: 300px;
    margin-left: 0;
}
.item-headers-1 {
    width: 300px;
    color: #daa75c;
}
.item-headers-2, .item-headers-3 {
    width: 125px;
}
.item-headers-4 {
    width: 190px;
}
.item-headers-content {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-bottom: 3px solid #b2d1ff;
    font-size: 14px;
    margin-left: 1px;
    vertical-align: bottom;
}
.item-headers-content0 {
    display: inline-block;
    /* height: 30px;
    line-height: 30px; */
    /* text-align: center; */
    font-size: 14px;
    margin-left: 3px;
    vertical-align: bottom;
}
.realpay .box {
    text-align: right;
    margin-top: 15px;
}
.realpay .box .box__wrapper {
    display: inline-block;
    border: 1px solid #f00180;
}
.realpay .box .box__wrapper .box__shadow {
    /* border: 3px solid #fff0e8; */
    min-width: 230px;
    padding: 10px 5px 10px 20px;
}
.realpay .realpay--title {
    font-weight: 700;
    color: #333;
}
.realpay .realpay--price-symbol {
    font-size: 26px;
    margin-right: 4px;
    color: #999;
}
.realpay .realpay--price {
    color: #f00180;
    font: 700 26px tahoma;
}
.order-confirmAddr {
    line-height: 1.6;
    margin-top: 10px;
}
.order-confirmAddr .confirmAddr-title {
    font-weight: 700;
    color: #333;
}
.order-confirm-eticket {
    line-height: 1.6;
    margin-top: 10px;
}
.submitOrder-container {
    text-align: right;
    margin-top: -1px;
}
.submitOrder-container .wrapper {
    display: inline-block;
    padding: 0 0 5px 5px;
}
.submitOrder-container .go-btn {
    display: inline-block;
    width: 182px;
    height: 39px;
    position: relative;
    vertical-align: middle;
    line-height: 39px;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background: #f00180;
    color: #fff;
}
.operations {
    display: block;
    position: relative;
}
.next-btn.next-btn-normal {
    border-style: solid;
    background-color: #fff;
    border-color: #c4c6cf;
}

.next-btn.next-medium {
    border-radius: 3px;
    padding: 0 12px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    border-width: 1px;
    color: #f00180;
    cursor: pointer;
    border: 1px solid #f00180;
}
</style>


// WEBPACK FOOTER //
// src/components/car/buy_liji.vue